/* eslint-disable */
export function addMonths (date, count) {
  if (date && count) {
    var m, d = (date = new Date(+date)).getDate()
    date.setMonth(date.getMonth() + count, 1)
    m = date.getMonth()
    date.setDate(d)
    if (date.getMonth() !== m) date.setDate(0)
  }
  return date
}

export function getThisMonthStart(dateAdded) {
  var monthsSinceStart = 0;
  var now = new Date();
  while(addMonths(dateAdded, monthsSinceStart) < now) {
    monthsSinceStart++;
  }
  return addMonths(dateAdded, monthsSinceStart - 1);
}

export function getThisMonthEnd(dateAdded) {
  var monthsSinceStart = 0;
  var now = new Date();
  while(addMonths(dateAdded, monthsSinceStart) < now) {
    monthsSinceStart++;
  }
  return addMonths(dateAdded, monthsSinceStart);
}

export default {
  addMonths,
  getThisMonthStart,
  getThisMonthEnd,
}
